import * as React from 'react'

// Since our version of react doesn't support fragments, this is a small polyfill where I
// can't find a neater alternative.
// NOTE TO WHOMEVER REMOVES THIS: make sure to update any styles that reference this
const Fragment: React.SFC = ({ children }) => <div className="fragment">{children}</div>

export default Fragment
